import { render, staticRenderFns } from "./RegisterStaff.vue?vue&type=template&id=502d7844&scoped=true"
import script from "./RegisterStaff.vue?vue&type=script&lang=js"
export * from "./RegisterStaff.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegisterStaff.vue?vue&type=style&index=1&id=502d7844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d7844",
  null
  
)

export default component.exports